/**
 * Icon sizing theme values.
 */
import { Components } from "@oui/system/components"

const sizing: Components["Icon"]["sizing"] = {
  xs: 10,
  sm: 16,
  md: 20,
  lg: 32,
  xl: 44
}

export default { sizing }
